import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {triggerEdapEvent, edapTrigger} from '../../../utils/triggerEdap';
import {namedEvents} from '../../../utils/edap';

function HelpMenu({help}) {
    const context = useContext(TrackingContext);

    function handleHelpMenuClick(item) {
        return () => {
            const actionLocation = `header.${item.text.replace(/\s/g, '').toLowerCase()}`;
            triggerEdapEvent(context, actionLocation);
            edapTrigger(namedEvents.CTA_SELECTED, {action_location: actionLocation, event_action: namedEvents.CTA_HEADER_TAB_CLICKED});
            return true;
        };
    }
    
    const renderItem = (item, index) => {
        return (
            <a
                className="site-header-tray__menu-item-link site-header-tray__menu-item-link--help"
                data-bypass="true"
                href={item.link}
                key={`link-${index}`}
                onClick={handleHelpMenuClick(item)}
            >
                {item.text}
            </a>
        );
    };

    return (
        <div className="site-header-tray__menu site-header-tray__drawer">
            <div className="site-header-tray__items">
                {help.items.map(renderItem)}
            </div>
        </div>
    );
}

HelpMenu.propTypes = {
    help: PropTypes.shape({})
};

export {HelpMenu};